// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__MJws-","chartTitle":"Chart_chartTitle__xouo+"};